import { axiosInstance } from 'services/api/base.api';
import { paths } from 'services/api/paths';
import { ParamsGetTrackingLogs } from '../type/tracking-logs.type';

export const getAllTrackingLogs = async (params: ParamsGetTrackingLogs): Promise<any> => {
  return axiosInstance.get(paths.getTracking(), { params }).then(response => response.data.data);
};
